
export const FailSvg = () => {
  return (
    <svg width="102" height="101" viewBox="0 0 102 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="72.0625" y="21" width="12" height="71" transform="rotate(45 72.0625 21)" fill="#FF6060" />
      <rect x="21.8594" y="29.3438" width="12" height="71" transform="rotate(-45 21.8594 29.3438)" fill="#FF6060" />
    </svg>
  );
}